<div class="dashboard">
  <app-container>
    <app-bread-crumbs></app-bread-crumbs>
    <h4 class="title">
      {{ page?.translation?.data?.title || "Регуляторний дашборд" }}
    </h4>

    <div class="dashboard-wrapper">
      <div class="desc" [innerHTML]="page?.translation?.data?.desc">
        Кількість суб’єктів господарювання, що підпадають  під дію регулювання
      </div>

      <div class="total">
        <span class="number">{{ dashboard()?.totalSubjects | number }}</span>
        <span class="label">{{ page?.translation?.data?.totalSubjects }}</span>
      </div>

      <div class="progress-bar">
        <div
          class="bar"
          [ngClass]="[
            getColor('large'),
            hovered && hovered !== 'large' ? 'inactive' : '',
          ]"
          [ngStyle]="{ width: getPercentage(dashboard()?.large || 0) }"
          (mouseenter)="hover('large')"
          (mouseleave)="hover(null)"
        ></div>
        <div
          class="bar"
          [ngClass]="[
            getColor('medium'),
            hovered && hovered !== 'medium' ? 'inactive' : '',
          ]"
          [ngStyle]="{ width: getPercentage(dashboard()?.medium || 0) }"
          (mouseenter)="hover('medium')"
          (mouseleave)="hover(null)"
        ></div>
        <div
          class="bar"
          [ngClass]="[
            getColor('small'),
            hovered && hovered !== 'small' ? 'inactive' : '',
          ]"
          [ngStyle]="{ width: getPercentage(dashboard()?.small || 0) }"
          (mouseenter)="hover('small')"
          (mouseleave)="hover(null)"
        ></div>
        <div
          class="bar"
          [ngClass]="[
            getColor('micro'),
            hovered && hovered !== 'micro' ? 'inactive' : '',
          ]"
          [ngStyle]="{ width: getPercentage(dashboard()?.micro || 0) }"
          (mouseenter)="hover('micro')"
          (mouseleave)="hover(null)"
        ></div>
      </div>

      <div class="cards">
        <div
          class="card"
          [class.active]="hovered === 'large'"
          [class.inactive]="hovered && hovered !== 'large'"
          (mouseenter)="hover('large')"
          (mouseleave)="hover(null)"
        >
          <span class="badge" [ngClass]="getColor('large')">{{
            page?.translation?.data?.large
          }}</span>
          <div class="count">{{ dashboard()?.large | number }}</div>
        </div>
        <div
          class="card"
          [class.active]="hovered === 'medium'"
          [class.inactive]="hovered && hovered !== 'medium'"
          (mouseenter)="hover('medium')"
          (mouseleave)="hover(null)"
        >
          <span class="badge" [ngClass]="getColor('medium')">{{
            page?.translation?.data?.medium
          }}</span>
          <div class="count">{{ dashboard()?.medium | number }}</div>
        </div>
        <div
          class="card"
          [class.active]="hovered === 'small'"
          [class.inactive]="hovered && hovered !== 'small'"
          (mouseenter)="hover('small')"
          (mouseleave)="hover(null)"
        >
          <span class="badge" [ngClass]="getColor('small')">{{
            page?.translation?.data?.small
          }}</span>
          <div class="count">{{ dashboard()?.small | number }}</div>
        </div>
        <div
          class="card"
          [class.active]="hovered === 'micro'"
          [class.inactive]="hovered && hovered !== 'micro'"
          (mouseenter)="hover('micro')"
          (mouseleave)="hover(null)"
        >
          <span class="badge" [ngClass]="getColor('micro')">{{
            page?.translation?.data?.micro
          }}</span>
          <div class="count">{{ dashboard()?.micro | number }}</div>
        </div>
      </div>
    </div>

    <div class="costs">
      <div class="costs-wrapper">
        <div class="item-wrapper">
          @for (item of indicators(); track item.id) {
            <div class="item">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="count">
                {{ item.values[selectedPeriods[item.id]] | number }}
                <span>грн</span>
              </div>
              <div class="btn">
                <button
                  class="_btn outline x-small"
                  (click)="switchPeriod(item.id, '1')"
                  [class.active]="selectedPeriods[item.id] == '1'"
                >
                  {{ page?.translation?.data?.selectedPeriods1 }}
                </button>
                <button
                  class="_btn outline x-small"
                  (click)="switchPeriod(item.id, '5')"
                  [class.active]="selectedPeriods[item.id] == '5'"
                >
                  {{ page?.translation?.data?.selectedPeriods5 }}
                </button>
              </div>
            </div>
          }
        </div>

        <div class="dashboard-wrappers">
          <div class="dashboard-chart">
            <app-dashboard-chart
              [title]="page?.translation?.data?.chartTitleCov"
              [completedText1]="
                '-' + page?.translation?.data?.chartCompletedCovText1
              "
              [completedText2]="
                '-' + page?.translation?.data?.chartCompletedCovText2
              "
              [completedText3]="
                '-' + page?.translation?.data?.chartCompletedCovText3
              "
              [centerText1]="page?.translation?.data?.chartCompletedCovText1"
              [centerText2]="page?.translation?.data?.chartCompletedCovText2"
              [centerText3]="page?.translation?.data?.chartCompletedCovText3"
              [percentage]="dashboard()?.praAcceptedPercent"
              [percentageInReview]="dashboard()?.praUnderReviewPercent"
              [percentageReject]="dashboard()?.rejectedPercent"
              [chartColors]="[
                'rgba(254, 201, 22, 1)',
                'rgba(51, 202, 127, 1)',
                'rgba(255, 68, 68, 1)',
              ]"
            >
            </app-dashboard-chart>
          </div>
          <div class="dashboard-chart">
            <app-dashboard-chart
              [title]="page?.translation?.data?.chartTitleOmc"
              [completedText1]="
                '-' + page?.translation?.data?.chartCompletedOmcText1
              "
              [completedText2]="
                '-' + page?.translation?.data?.chartCompletedOmcText2
              "
              [completedText3]="
                '-' + page?.translation?.data?.chartCompletedOmcText3
              "
              [centerText1]="page?.translation?.data?.chartCompletedOmcText1"
              [centerText2]="page?.translation?.data?.chartCompletedOmcText2"
              [centerText3]="page?.translation?.data?.chartCompletedOmcText3"
              [percentage]="dashboard()?.omcAcceptedPercent || 0"
              [percentageInReview]="dashboard()?.omcProposalPercent || 0"
              [percentageReject]="dashboard()?.omcNoCommentPercent || 0"
              [chartColors]="[
                'rgba(254, 201, 22, 1)',
                'rgba(51, 202, 127, 1)',
                'rgba(255, 68, 68, 1)',
              ]"
            >
            </app-dashboard-chart>
          </div>
        </div>
      </div>

      <div class="stats">
        <app-stats-dashboard [variant]="'secondary'"></app-stats-dashboard>
      </div>

      <app-region-assessment></app-region-assessment>

      <div class="history">
        <h6 class="title">{{ page?.translation?.data?.historyTitle }}</h6>
        <div class="history-wrapper">
          <div class="list">
            <div class="item title">
              <div class="date-title">Назва ПРА</div>
              <div class="name-title">Дата прийняття</div>
              <div class="name-title">Регуляторний орган</div>
            </div>
            @for (item of validityProjects(); track item) {
              <div class="item">
                <div class="name">{{ item.title }}</div>
                <div class="date">{{ item.acceptanceDate }}</div>
                <div class="agency">{{ item.actTerritoryTypeTitle }}</div>
                <img
                  [routerLink]="['/acts', item.regPlanItemId]"
                  src="assets/img/icons/arrow-right.svg"
                  alt=""
                />
              </div>
            }
          </div>
        </div>
        <app-paginator
          [totalItems]="totalItems"
          [currentPage]="currentPage"
          [itemsPerPage]="itemsPerPage"
          (pageChange)="onPageChange($event)"
        >
        </app-paginator>
      </div>
    </div>
  </app-container>
</div>
